export default "<span>{{version}}</span>\n"